import React from "react";

import { GuidedTour } from "@/components/guide/GuidedTour";

import { useHomeTour } from "../hooks/useHomeTour";

export interface HomeTourProps {
  accountId?: number;
  isMobile: boolean;
  backendLoaded: boolean;
  startupPopupEvaluated: boolean;
  notificationPermissionChecking: boolean;
  investmentStyleLoading: boolean;
  cashflowLoading: boolean;
  blockingDialogOpen: boolean;
}

export const HomeTour: React.FC<HomeTourProps> = ({ accountId, isMobile, backendLoaded, startupPopupEvaluated, notificationPermissionChecking, investmentStyleLoading, cashflowLoading, blockingDialogOpen }) => {
  const homeTour = useHomeTour({
    accountId,
    isMobile,
    ready: backendLoaded && startupPopupEvaluated && !notificationPermissionChecking &&
      !investmentStyleLoading && !cashflowLoading && !blockingDialogOpen,
  });
  return <GuidedTour run={homeTour.run} steps={homeTour.steps} stepIndex={homeTour.stepIndex} onNext={homeTour.next} onComplete={homeTour.complete} />;
};
